import type { LoaderFunctionArgs } from '@remix-run/node'
import { redirect } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ShopLoginForm } from '~/components/shop-login-form'
import { env } from '~/env.server'
import styles from '~/routes/_index/styles.module.css'
import { login } from '~/shopify.server'

export const meta = () => {
  return [
    { title: 'Cart2Cart' },
    {
      name: 'description',
      content:
        'Unique online shopping cart migration service that allows you to transfer all your customers, products and orders from one shopping cart to another.'
    }
  ]
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url)

  if (url.searchParams.get('shop')) {
    throw redirect(`/app?${url.searchParams.toString()}`)
  }

  return { showForm: Boolean(login), appName: env.TITLE_APP_NAME }
}

export default function App() {
  const { t } = useTranslation()
  const { showForm, appName } = useLoaderData<typeof loader>()
  const [shop, setShop] = useState('')

  return (
    <div className={styles.index}>
      <div className={styles.content}>
        <p className={styles.heading}>{t('appTitle', { appName })}</p>
        {showForm && (
          <ShopLoginForm
            className={styles.form}
            action="/auth/login"
            value={shop}
            onChange={setShop}
            label={t('landing.shopDomain')}
            submitLabel={t('landing.login')}
          />
        )}
      </div>
    </div>
  )
}
